require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./cloud-20190826-12.json") })
        }
      }, "path---cloud-20190826-12");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---cloud-20190826-12!./.cache/json/cloud-20190826-12.json
// module id = 647
// module chunks = 231608221292675